import { Configuration } from '@verona/address-check-public-api';
import { firstValueFrom } from 'rxjs';
import { authToken$ } from '../../store';

export const apiConfiguration = new Configuration({
  basePath: '/api',
  accessToken: () => firstValueFrom(authToken$),
});
